import slick from '@accessible360/accessible-slick';
import $ from 'jQuery';

export default function () {
	$(function() {
		homepage_hero();
		widestWord();
	});

	$(window).on('resize', function() {
		widestWord();
	});

	const slickDefaults = {
		adaptiveHeight: false,
	};

	class Slider {
		/**
		 * Slider Constructor
		 * @param {HTML Element} element Element to transform into a slick slider.
		 * @param {object} options Optional settings to overwrite the defaults.
		 */
		constructor(element, options) {
			// Grabs reference to the passed in element.
			this.element = element;

			// We can pass in alternate options to overwrite the defaults.
			this.settings = { ...slickDefaults, ...options };

			// Sets a slider variable from the returned slick slider instance built.
			this.slider = this.build();

			// Calls a utility ready function when everything is done.
			this.ready();
		}

		/**
		 * Builds out a slick slider from the element and the settings.
		 * @returns jQuery Element
		 */
		build() {
			return $(this.element).slick(this.settings);
		}

		/**
		 * Utility function to add a ready class to the element.
		 */
		ready() {
			this.element.classList.add('ready');
		}
	}

	function homepage_hero() {
		const $carousel = $('.block--hero-homepage');

		if ($carousel.length) {
			$('.hero-homepage--events', $carousel).each(function() {
				const $thisSlider = $(this);
				let el = $thisSlider[0];
				const $sliderContainer = $thisSlider.parents('.hero-homepage--bottom');
				const $prevButton = $sliderContainer.find('.hero-homepage--previous-button');
				const $nextButton = $sliderContainer.find('.hero-homepage--next-button');
				const $pagerContainer = $sliderContainer.find('.hero-homepage--pagination');

				const slickSettings = {
					slidesToShow: 1.4,
					slidesToScroll: 1,
					dots: true,
					arrows: true,
					infinite: false,
					speed: 700,
					prevArrow: $prevButton,
					nextArrow: $nextButton,
					appendDots: $pagerContainer,
	        dotsClass: 'slick--pagination', // Slick generates a <ul.carousel-pagination> within the appendDots container
	        customPaging: function (slider, i) {
	          const slideNumber = (i + 1);
	          const totalSlides = slider.slideCount;
	          return '<button class="pagination-control" tabindex="-1"><span class="visually-hidden">View slide ' + slideNumber + ' of ' + totalSlides + '</span></button>';
	        },
					responsive: [
						{
							breakpoint: 800,
							settings: {
								slidesToShow: 1,
							}
						},
					]
				};

				if (!el.Slider) {
					el.Slider = new Slider(el, slickSettings);
				}
			});
		}

		$('.hero-homepage--image--first-column--inner').each(function() {
			$(this).clone().insertAfter( $(this) );
		});
	}

	function widestWord() {
		var widest = 0;
		setTimeout(function() {
			$('.hero-homepage--animated-word--inner span').each(function() {
				var currentWidth = $(this).width();
				if ( currentWidth > widest ) {
					widest = currentWidth;
				}
			});
			$('.hero-homepage--animated-word').width(widest);
		}, 1000);
	}
}
